import settings from './settings/settings.routes';
import conversation from './conversation/conversation.routes';
import { routes as searchRoutes } from '../../modules/search/search.routes';
import { routes as contactRoutes } from './contacts/routes';
import { routes as notificationRoutes } from './notifications/routes';
import { routes as inboxRoutes } from './inbox/routes';
import { frontendURL } from '../../helper/URLHelper';
import helpcenterRoutes from './helpcenter/helpcenter.routes';
import campaignsRoutes from './campaigns/campaigns.routes';
import voiceRoutes from './voice/voice.routes';
import workforceRoutes from './workforce/workforce.routes';
import qaDashboardRoutes from './qa/qa.routes';
import myQaRoutes from './qa/myQa.routes';
import engageRoutes from './engage/engage.routes';
import teamManagementRoutes from './teamManagement/teamManagement.routes';
import telegramInternalRoutes from './telegramInternal/telegramInternal.routes';
import { routes as ailabRoutes } from './ailab/ailab.routes';
import AppContainer from './Dashboard.vue';
import Suspended from './suspended/Index.vue';
import AccessRestricted from './accessRestricted/Index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId'),
      component: AppContainer,
      meta: {
        buildRevision: '2026-02-23-hotfix-asset-cache',
      },
      children: [
        ...ailabRoutes,
        ...inboxRoutes,
        ...conversation.routes,
        ...settings.routes,
        ...contactRoutes,
        ...searchRoutes,
        ...notificationRoutes,
        ...helpcenterRoutes.routes,
        ...qaDashboardRoutes.routes,
        ...myQaRoutes.routes,
        ...engageRoutes.routes,
        ...teamManagementRoutes.routes,
        ...telegramInternalRoutes.routes,
        ...workforceRoutes.routes,
        ...campaignsRoutes.routes,
        ...voiceRoutes.routes,
      ],
    },
    {
      path: frontendURL('accounts/:accountId/suspended'),
      name: 'account_suspended',
      meta: {
        permissions: ['administrator', 'agent', 'custom_role'],
      },
      component: Suspended,
    },
    {
      path: frontendURL('accounts/:accountId/access-restricted'),
      name: 'access_restricted',
      meta: {
        permissions: ['administrator', 'agent', 'custom_role'],
      },
      component: AccessRestricted,
    },
  ],
};
